import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;
const prefix = `/api/v1`;

const axios = createAxiosInstance(URL);

export const sendMessageToSupport = (data, params = {}) => {
    return axios.post(`${prefix}/support/`, data, { params });
};
